import axios from 'api/axios'
function roundDown(number) {
  return Math.floor(number * 1000000) / 1000000
}

/**
 * The tipes of modal
 * @readonly
 * @enum {string}
 */
export const PresenceControlActions = {
  Entrada: 'E',
  Salida: 'S',
}

/**
 * Get The Geolocation Data Async
 *
 * @param {PositionOptions} options
 * @returns {Promise<GeolocationPosition>}
 */
export const getGeoLocation = (options) => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, options)
  })
}

/**
 * Class to controll the presence control
 */
class FichajesController {
  /**
   * This method will create a new enry on the
   * presence control table acording to the action_tipe `rhp_tipo_salidas`
   *
   * @static
   * @async
   * @param {PresenceControlActions} tipo_accion - Accion Type to create
   * @param {string} [exit_code] - If is a exit type this param must be provided
   * @example
   * await FichajesController.create(PresenceControlActions.Entrada)
   * // Or if you want to leave
   * await FichajesController.create(PresenceControlActions.Salida, '00SA')
   * @throws {Error}
   * @returns {Promise<void>}
   */
  static async create(
    action_type = PresenceControlActions.Entrada,
    exit_code = undefined,
    card = null,
    terminal = null,
  ) {
    const newPosition = []
    try {
      if (navigator.geolocation) {
        const geoPosition = await getGeoLocation()
        /**@type {import('leaflet').LatLngTuple} */
        newPosition[0] = geoPosition.coords.latitude
        newPosition[1] = geoPosition.coords.longitude
      }
    } catch (error) {
      // Geolocation error handled
    }

    const body = {
      entrada_salida: action_type,
      latitud: newPosition && newPosition.length > 0 ? roundDown(newPosition[0]) : null,
      longitud: newPosition && newPosition.length > 0 ? roundDown(newPosition[1]) : null,
      fecha_terminal: new Date().toISOString(),
      card: card,
      terminal: terminal,
    }

    if (exit_code) body['tipo_salida'] = exit_code

    const endpoint = card ? '/panel/fichajes/' : '/fichajes/'

    const response = await axios.post(endpoint, body)
    return response.data
  }

  static async delete(id) {
    const response = await axios.delete(`/fichajes/${id}/`)
    return response.data
  }
}

export default FichajesController
